// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__6V_Z0","disabled":"FileBtn_disabled__3iFK1","warn":"FileBtn_warn__3jHF0","fade":"FileBtn_fade__-ElJ9"};